// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-channel{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: auto;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.popup-content {
  background: aliceblue;
  width: auto;
  max-width: 600px;
  height: 100%;
  padding: 20px;
  overflow-y: auto;
  position: relative;
  border-left: 1px solid #ccc;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 24px;
  border: none;
  background: none;
  cursor: pointer;
}

@media (max-width: 768px) {
  .popup-content {
    max-width: 90%;
  }
}

.no-channels {
  text-align: center;
}

.pageHeading {
  font-family: 'Google Sans', sans-serif;
  font-size: 2.5rem;
  color: #0f0f0f !important;
}

.no-channel-img {
  width: 70vw;
  max-width: 900px;
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
} 

.channels {
  cursor: pointer;
  border-radius: 10px;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.channel-card:hover {
  transform: translateY(-5px);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
}

.channel-avatar {
  width: 100px;
  height: 100px;
  background-color: #435e9f;
  color: white;
  font-size: 40px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.delete-btn {
  border: none;
  background: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
}

.delete-btn:hover {
  color: rgb(223, 137, 137);
}

.channelDesc {
  font-size: 14px;
  height: 100px;
  overflow: hidden;
}

.help-section {
  background-color: #f8f9fa; /* Light gray background */
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}
.help-section h4 {
  font-weight: bold;
  margin-bottom: 15px;
}
.help-section p {
  font-size: 14px;
  margin-bottom: 10px;
}

.help {
  background-color: #f8f9fa;
  border-radius: 2%;
}

@media screen and (max-width: 768px) {
  .help {
    background-color: #f8f9fa;
    border-radius: 2%;
    margin-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChannelPage/channel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".create-channel{\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: auto;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.popup-content {\n  background: aliceblue;\n  width: auto;\n  max-width: 600px;\n  height: 100%;\n  padding: 20px;\n  overflow-y: auto;\n  position: relative;\n  border-left: 1px solid #ccc;\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  font-size: 24px;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .popup-content {\n    max-width: 90%;\n  }\n}\n\n.no-channels {\n  text-align: center;\n}\n\n.pageHeading {\n  font-family: 'Google Sans', sans-serif;\n  font-size: 2.5rem;\n  color: #0f0f0f !important;\n}\n\n.no-channel-img {\n  width: 70vw;\n  max-width: 900px;\n  height: auto;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n} \n\n.channels {\n  cursor: pointer;\n  border-radius: 10px;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.channel-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);\n}\n\n.channel-avatar {\n  width: 100px;\n  height: 100px;\n  background-color: #435e9f;\n  color: white;\n  font-size: 40px;\n  font-weight: bold;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.delete-btn {\n  border: none;\n  background: none;\n  color: red;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.delete-btn:hover {\n  color: rgb(223, 137, 137);\n}\n\n.channelDesc {\n  font-size: 14px;\n  height: 100px;\n  overflow: hidden;\n}\n\n.help-section {\n  background-color: #f8f9fa; /* Light gray background */\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n}\n.help-section h4 {\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n.help-section p {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.help {\n  background-color: #f8f9fa;\n  border-radius: 2%;\n}\n\n@media screen and (max-width: 768px) {\n  .help {\n    background-color: #f8f9fa;\n    border-radius: 2%;\n    margin-top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
